import { Star } from 'lucide-react';
import React from 'react';
import { Button } from '@/Components/shadcn';
import { cn } from '@/lib/utils';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';
import { useCandidatesClient } from '@/Hooks/ClientHooks';
import { useNotificationContext } from '@/Context/NotificationContext';

function CandidateFavorite(): React.JSX.Element {
    const { assessmentId, results, updateIsFavorite } = useCandidatesResultsContext();
    const { showFailToaster } = useNotificationContext();
    const client = useCandidatesClient();

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            data-testid="FavoriteCheckbox"
            aria-pressed={results.isFavorite}
            aria-label={results.isFavorite ? 'Remove favorite' : 'Add favorite'}
            onClick={async () => {
                try {
                    const newValue = !results.isFavorite;
                    await client.saveFavoriteAsync(assessmentId, results.candidateId, newValue);
                    updateIsFavorite(newValue);
                } catch {
                    showFailToaster();
                }
            }}
        >
            <Star
                className={cn('size-5', results.isFavorite ? 'fill-primary text-primary' : 'text-muted-foreground')}
                aria-hidden
            />
        </Button>
    );
}

export default CandidateFavorite;
